// Specific, locally served stock photos. Source and license records: EXTRA_IMAGE_SOURCES.md.
// Each scene is illustrative only and does not depict an Offlico professional or customer.
const exceptionImage = (filename, alt) => ({
  src: `/public-assets/professions/exceptions/${filename}.webp`,
  alt,
  width: 1200,
  height: 900,
})

const dentalExamination = exceptionImage(
  'dental-clinical-examination',
  'Gloved hands holding dental instruments beside a patient in a clinic',
)
const facePainting = exceptionImage(
  'child-face-painting',
  "Adult painting a colourful design on a child's face",
)
const balloonEvent = exceptionImage(
  'balloon-decorated-event-venue',
  'Event venue decorated with pink balloons and dining tables',
)
const passengerCarDriving = exceptionImage(
  'taxi-driver-cab',
  'Driver holding the steering wheel inside a car',
)

export const professionImageOverrides = {
  MP003: dentalExamination,
  MP004: dentalExamination,
  MP005: dentalExamination,
  MP006: exceptionImage('diagnostic-shoulder-ultrasound', "Ultrasound probe held against a patient's shoulder beside a scan monitor"),
  MP013: exceptionImage('optometry-eye-examination', 'Child seated beside eye-examination equipment in a clinic'),
  MP017: exceptionImage('phlebotomy-arm-blood-draw', "Gloved hand drawing blood from a person's arm with a syringe"),
  MP063: exceptionImage('tattoo-artist-applying-arm-design', "Gloved hand tattooing a client's forearm"),
  MP128: exceptionImage('aquarium-tropical-fish', 'Fish swimming among plants in an aquarium'),
  MP136: exceptionImage('beekeeper-inspecting-hive', 'Person in a beekeeper suit lifting a frame from a hive'),
  MP214: exceptionImage('oil-sheen-wet-pavement', 'Rainbow-coloured sheen from spilled fuel on wet pavement'),
  MP256: exceptionImage('bicycle-gear-repair', 'Hands adjusting a bicycle rear gear mechanism with a tool'),
  MP260: exceptionImage('heavy-vehicle-truck-engine-repair', "Mechanic working beneath a heavy truck's front panel"),
  MP261: exceptionImage('marine-ship-propeller-work', 'Worker repairing a large ship propeller in a yard'),
  MP320: passengerCarDriving,
  MP327: passengerCarDriving,
  MP330: passengerCarDriving,
  MP341: exceptionImage('art-conservator-statue-restoration', 'Conservator working on a carved stone statue from scaffolding'),
  MP343: exceptionImage('commercial-drone-operator', 'Person operating a drone over an open field'),
  MP356: balloonEvent,
  MP360: facePainting,
  MP368: balloonEvent,
  MP369: facePainting,
  MP370: exceptionImage('florist-arranging-bouquet', 'Hands arranging flowers into a bouquet'),
  MP384: exceptionImage('food-truck-customer-service', 'Food truck with a person at its serving hatch'),
  MP385: exceptionImage('mobile-barista-coffee-cart', 'Person preparing drinks at an outdoor coffee cart'),
  MP386: exceptionImage('mobile-bartender-outdoor-bar', 'Bartender pouring a drink at an outdoor bar'),
}
